import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import HelperMixin from "@/mixins/HelperMixin";
import TasksMixin from "@/mixins/TasksMixin.vue";
import AppModal from "@/components/AppModal";
import PpcBAStateCell from "@/components/PpcBAStateCell.vue";
import PpcBAProductInfoCell from "@/components/PpcBAProductInfoCell.vue";
import PpcBAPrioritizedByCell from "@/components/PpcBAPrioritizedByCell.vue";
import PpcBABoostCell from "@/components/PpcBABoostCell.vue";
import PpcBAProductMarginCell from "@/components/PpcBAProductMarginCell.vue";
import PpcBAAcosRoasCell from "@/components/PpcBAAcosRoasCell.vue";
import PpcBAMaxPotentialPercentCell from "@/components/PpcBAMaxPotentialPercentCell.vue";
import PpcBAVsLastWeekSpendCell from "@/components/PpcBAVsLastWeekSpendCell.vue";
import PpcBASBPortfolioCell from "@/components/PpcBASBPortfolioCell.vue";
import PpcBASBBudgetCell from "@/components/PpcBASBBudgetCell.vue";
import { currencies_symbols } from '@/utils/currencies';
import PpcBudgetAllocationWeeklyBudgetEdit from "@/components/PpcBudgetAllocationWeeklyBudgetEdit";
import { amz_sp_api_marketplace_ids_country_domains_flipped, country_code_amz_sp_api_marketplace_ids_flipped } from '@/utils/countries';
import PlayIcon from "@/components/icons/PlayIcon.vue";
import PauseIcon from "@/components/icons/PauseIcon.vue";
import AppIcon from "@/components/AppIcon";
export default {
  name: "PpcSbBudgetAllocationItem",
  emits: ["item-update", "weekly-budget-edit"],
  mixins: [HelperMixin, TasksMixin],
  components: {
    AppModal,
    PpcBAStateCell,
    PpcBAProductInfoCell,
    PpcBAPrioritizedByCell,
    PpcBABoostCell,
    PpcBAProductMarginCell,
    PpcBAAcosRoasCell,
    PpcBAMaxPotentialPercentCell,
    PpcBAVsLastWeekSpendCell,
    PpcBASBPortfolioCell,
    PpcBASBBudgetCell,
    PpcBudgetAllocationWeeklyBudgetEdit,
    PlayIcon,
    PauseIcon,
    AppIcon
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    mode: {
      type: String,
      default: ""
    },
    weeklyBudgetTarget: {
      type: String,
      default: null
    },
    last: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String
    },
    selected_profile_id: {
      type: String
    },
    still_initializing: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currency_precision: 0,
      calculatedCapForMode: {
        acos: this.aCOSCap,
        roas: this.rOASCap
      },
      campaignEditTaskIdentifier: "",
      confirmModal: false,
      budgetUpdateModal: false,
      updated_campaign_state: "",
      updated_campaign_budget: 0,
      updated_campaign_portfolio_id: "",
      confirm_modal_text: "",
      confirm_modal_type: "",
      edit_campaign_loading: false,
      badgeTextMapping: {
        activated: "Newly activated",
        paused: "Paused",
        inactive: "Inactive",
        paused_unchanged: "",
        updated: ""
      },
      country_code_amz_sp_api_marketplace_ids_flipped,
      amz_sp_api_marketplace_ids_country_domains_flipped
    };
  },
  mounted() {
    this.campaignEditTaskIdentifier = this.current_workspace.workspace_id + "_" + this.item.campaign_id + "_" + "ppc_edit_campaign_sb";
    this.checkIfAnyPreviousUpdateTaskIsRunning();
  },
  computed: {
    ...mapState({
      bid_settings: state => state.ppc_settings.bid_settings,
      current_workspace: state => state.workspace.current_workspace,
      sb_portfolio: state => state.ppc_settings.sb_portfolio,
      sb_ppc_campaigns: state => state.ppc_settings.sb_ppc_campaigns
    }),
    ...mapGetters(["getCountryFlag"]),
    campaignState() {
      const campaignStateMap = {
        "PAUSED": false,
        "ENABLED": true
      };
      return campaignStateMap[this.item.state ?? "ENABLED"];
    },
    campaignAIState() {
      return this.item?.portfolio_id?.toString() === this.sb_portfolio?.portfolioId?.toString() ? true : false;
    },
    processedItem() {
      //console.log(this.item);
      //console.log(this.getCountryFlag(this.item.country_code));
      return {
        id: this.item.campaign_id,
        name: this.item.name,
        image: this.item.asin_image_link,
        flag: this.getCountryFlag(country_code_amz_sp_api_marketplace_ids_flipped[amz_sp_api_marketplace_ids_country_domains_flipped[this.item.sales_channel?.toLowerCase()]]),
        countryCode: country_code_amz_sp_api_marketplace_ids_flipped[amz_sp_api_marketplace_ids_country_domains_flipped[this.item.sales_channel?.toLowerCase()]],
        boost: this.item?.boost ?? 1,
        cap: this.calculatedCapForMode[this.mode](this.item),
        acos4W: this.item.acos_4w,
        roas4W: this.item.roas_4w,
        adsNetProfit4W: this.item.sponsored_net_profit,
        revShare4W: this.item.revenue_share,
        productsMargin: this.item.weighted_margin_rate,
        productsMarginValue: this.item.weighted_margin,
        weeklyBudget: this.item.weekly_budget,
        maxWeeklyBudget: this.item.max_weekly_budget,
        maxSpendPotentialPercent: this.item.weekly_budget / this.item.max_weekly_budget,
        lastWeekSpend: this.item.last_week_spend,
        vsLastWeekSpend: this.item.weekly_budget - this.item.last_week_spend,
        adType: this.item.ad_types.join(" - "),
        result: this.item.result,
        rank: this.item.rank,
        isCoveredByAlgo: this.item.is_covered_by_algo,
        allocatedBudgetAI: this.item.allocated_budget_ai,
        budgetEvolution: this.item.budget_evolution
      };
    },
    getRowClass() {
      const result = [];
      const classMap = {
        true: "ba-row-regular",
        false: "ba-row-paused"
      };
      const campaignAIStateClassMap = {
        true: "",
        false: "ai-paused"
      };
      result.push(classMap[this.campaignState]);
      result.push(campaignAIStateClassMap[this.campaignAIState]);
      return result;
    },
    getCapColor() {
      const cap = this.processedItem.cap * 1;
      let result = "";
      if (this.mode == "acos") {
        const value = this.processedItem.acos4W * 1;
        if (value <= cap) {
          result = "ba-text-green";
        } else if (value > 2 * cap) {
          result = "ba-text-red";
        } else if (value > 1.25) {
          result = "ba-text-yellow";
        }
      }
      if (this.mode == "roas") {
        const value = this.processedItem.roas4W * 1;
        if (value >= cap) {
          result = "ba-text-green";
        } else if (value < 0.5 * cap) {
          result = "ba-text-red";
        } else if (value < 0.8 * cap) {
          result = "ba-text-yellow";
        }
      }
      return result;
    },
    currencySymbol() {
      return this.getCurrencySymbol();
    }
  },
  methods: {
    ...mapActions(["ppcEditCampaignSB", "ppcProductPrioritizationCampaignGroupUpdate"]),
    ...mapMutations(["ppcCampaignUpdateSBSet", "ppcSBProductPrioritizationPortfolioSet"]),
    getCurrencySymbol() {
      return currencies_symbols[this.currency];
    },
    onApplyCampaignStateEdit(value) {
      this.updated_campaign_state = value;
      this.confirm_modal_type = "state";
      this.onApplyCampaignEdit();
    },
    onApplyCampaignPortfolioEdit(value) {
      this.updated_campaign_portfolio_id = value;
      this.confirm_modal_type = "portfolio";
      this.onApplyCampaignEdit();
    },
    onApplyCampaignBudgetEdit(value) {
      if (value?.current !== this.processedItem.weeklyBudget) {
        this.updated_campaign_budget = value?.current;
        this.confirm_modal_type = "budget";
        this.budgetUpdateModal = false;
        this.onApplyCampaignEdit();
      }
    },
    onApplyCampaignEdit() {
      if (this.edit_campaign_loading) {
        return;
      }
      const confirmModalTextMap = {
        "state": `Are you sure you want to change the state of this campaign to ${this.updated_campaign_state}?`,
        "budget": `Are you sure you want to change the weekly budget of this campaign to ${this.currencySymbol}${Math.round(this.updated_campaign_budget * 100) / 100}? `,
        "portfolio": ` Are you sure you want to ${this.updated_campaign_portfolio_id ? "add" : "remove"} this campaign ${this.updated_campaign_portfolio_id ? "to" : "from"} OmnyAI SB portfolio?`
      };
      this.confirm_modal_text = confirmModalTextMap[this.confirm_modal_type];
      this.confirmModal = true;
    },
    async onApplyCampaignEditConfirm() {
      this.confirmModal = false;
      this.edit_campaign_loading = true;
      const updateDictMap = {
        "state": {
          state: this.updated_campaign_state
        },
        "budget": {
          budget: Math.round(this.updated_campaign_budget / 7 * 100) / 100
        },
        "portfolio": {
          portfolioId: this.updated_campaign_portfolio_id
        }
      };
      const campaignToEdit = {
        ...this.sb_ppc_campaigns?.filter(item => item.campaignId?.toString() === this.item.campaign_id.toString())?.[0],
        campaign_id: this.item.campaign_id,
        profile_id: this.selected_profile_id,
        country_code: this.processedItem.countryCode,
        update_dict: updateDictMap[this.confirm_modal_type]
      };
      const payload = {
        workspace_id: this.current_workspace.workspace_id,
        campaign: campaignToEdit,
        task_type: "ppc_edit_campaign_sb"
      };
      const data = await this.ppcEditCampaignSB(payload);
      if (data) {
        if (data.task_id === `${this.current_workspace.workspace_id}_${this.item.campaign_id}_ppc_edit_campaign_sb`) {
          this.campaignEditTaskIdentifier = `${this.current_workspace.workspace_id}_${this.item.campaign_id}_ppc_edit_campaign_sb`;
          this.executeTaskStatusHandler(data);
          this.checkTaskStatusPeriodically(this.campaignEditTaskIdentifier);
        }
      }
    },
    onBoostChange(value) {
      if (value !== this.processedItem.boost) {
        const item = {
          ...this.item
        };
        item.boost = value;
        this.updateCampaignGroup(item.boost);
        this.onItemUpdate(item);
      }
    },
    async updateCampaignGroup(boost) {
      const payload = [{
        campaign_group_id: this.item.campaign_id,
        profile_id: this.item.profile_id,
        country_code: this.processedItem.countryCode,
        campaign_group_name: this.item.portfolio_name,
        sales_channel: this.item.sales_channel,
        asin_group: '',
        boost: boost,
        is_blocked: ""
      }];
      await this.ppcProductPrioritizationCampaignGroupUpdate(payload);
    },
    onItemUpdate(newItem) {
      this.$emit("item-update", newItem);
    },
    rOASCap(item) {
      return 1 / this.aCOSCap(item);
    },
    aCOSCap(item) {
      return item?.weighted_margin_rate * Math.max(this.bid_settings?.non_branded_keyword_targeting ?? 0, this.bid_settings?.branded_keyword_product_targeting ?? 0, this.bid_settings?.competitor_product_targeting ?? 0) * (item?.boost ?? 1);
    },
    checkIfAnyPreviousUpdateTaskIsRunning() {
      this.getAsyncUpdate(this.campaignEditTaskIdentifier);
      this.checkTaskStatusPeriodically(this.campaignEditTaskIdentifier, 2000);
    },
    handleIdle() {},
    handleRunning() {
      this.edit_campaign_loading = true;
      this.checkTaskStatusPeriodically(this.campaignEditTaskIdentifier);
    },
    handleFailed(data) {
      this.edit_campaign_loading = false;
      this.confirm_modal_type = "";
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showDanger", {
        visible: true,
        message: "Campaign Edit Task failed \n" + data.task_result,
        delay: 60 // Show alert less than 60 secs
      });
      // throw new Error("Campaign Edit Task failed");
    },
    async handleFinished(data) {
      await this.ppcCampaignUpdateSBSet(data.task_result);
      await this.ppcSBProductPrioritizationPortfolioSet();
      this.edit_campaign_loading = false;
      this.confirm_modal_type = "";
      if (this.asyncUpdateInterval) {
        clearTimeout(this.asyncUpdateInterval);
        this.asyncUpdateInterval = null;
      }
      window.$bus.trigger("showSuccess", {
        visible: true,
        message: "Campaign Edit Task has finished with success",
        delay: 60 // Show alert less than 60 secs
      });
    }
  }
};